import work from './work';

const preacher = {
	consume: { food: 1.5, water: 1 },
	resilience: { food: 1.5, water: 1.5 },
	craftsmanship: { craftsmanship: 1 },
	luck: { luck: 1.1 },
	charisma: { charisma: 1.1 },
	startBonus: {},

	work: { [work.forage]: 0.75, [work.craft]: 1, [work.fabricate]: 1.5 },
};

export default preacher;
